import React, { useState, useMemo, useEffect } from "react";
import { useDispatch } from "react-redux";
import { classSessionAction } from "redux/actions";
import { TabModal } from "components";
import CategoryDetails from "./CategoryDetails";
import LocationDetails from "./LocationDetails";
import UserListBySession from "./UserListBySession";

export default function UserClassSessionPopup({ closeModal, data }) {
  // redux
  const dispatch = useDispatch();

  // states
  const [tabIndex, setTabIndex] = useState(0);
  const [details, setDetails] = useState();

  // useEffects
  useEffect(() => {
    console.log(JSON.stringify(data));
  }, []);

  useEffect(() => {
    
  }, [details]);

 

  // Popup tabs routes
  const modalTabs = useMemo(
    () => [
      {
        name: "Session Details",
        component: (
          <UserListBySession
            key={3}
            onClick={''}
            details={details}
            session_id={data.id}
          />
        )
      }
    ],
    [details]
  );

  return (
    <div className="session_users">
        <TabModal
            tabTitle={"User Class Sessions"}
            tabs={modalTabs}
            tabIndex={tabIndex}
            setTabIndex={index => setTabIndex(index)}
            closeModal={() => {
                setTabIndex(0);
                closeModal();
            }}
        />
    </div>
  );
}
